/**
 * Country edits land in the authoring catalog, never in the environment the
 * operator is looking at — they reach the apps only when the catalog is
 * published. Both flag toggles and the name editor have to say so, so the
 * wording lives here rather than in each of them.
 */
export const COUNTRY_PUBLISH_NOTE =
  "Saved to the catalog, not to this environment — it goes live with the next publish."

export const COUNTRY_PUBLISH_TOAST =
  "It reaches the apps with the next publish."
